import React, { useState, useEffect } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import CustomDateInput from '../CommonComp/CustomDateInput';
const EditSupplierBill = () => {
  const [options, setOptions] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedPo, setSelectedPo] = useState(null);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [purchaseItem, setPurchaseItem] = useState([]);
  const [discountData, setDiscountData] = useState([]);

  const handleVatValidation = (e) => {
    const value = e.target.value;
    // Allow only alphanumeric characters, no spaces or special characters
    const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);
    if (value !== alphanumericOnly) {
      e.target.value = alphanumericOnly;
    }
  };

  const [poDetails, setPoDetails] = useState({
    netAmount: '',
    discount: '',
    vatAmount: '',
    totalAmount: ''
  });

  const roundMoney = (n) => Math.round((Number(n) || 0) * 100) / 100;

  const sumLineDiscountPerUnit = (item) =>
    (parseFloat(item.retro) || 0) +
    (parseFloat(item.promptPayment) || 0) +
    (parseFloat(item.costToServe) || 0) +
    (parseFloat(item.offInvoice) || 0) +
    (parseFloat(item.bedsLeds) || 0) +
    (parseFloat(item.sugroRetro) || 0);

  const recalculateTotals = (items) => {
    let net = 0;
    let totalDisc = 0;
    let totalVat = 0;

    (items || []).forEach((i) => {
      const billQty =
        i.bill_qty !== '' && i.bill_qty !== undefined && i.bill_qty !== null && !Number.isNaN(parseInt(i.bill_qty, 10))
          ? parseInt(i.bill_qty, 10)
          : 0;
      if (billQty <= 0) {
        return;
      }
      const cost = parseFloat(i.cost) || 0;
      net += cost * billQty;
      const discPerUnit = sumLineDiscountPerUnit(i) || parseFloat(i.discount_amount) || 0;
      totalDisc += discPerUnit * billQty;
      const vatPct = parseFloat(i.vat_percentage) || 0;
      if (vatPct > 0) {
        const taxable = (cost - discPerUnit) * billQty;
        totalVat += taxable * (vatPct / 100);
      }
    });

    const netR = roundMoney(net);
    const discR = roundMoney(totalDisc);
    const vatR = roundMoney(totalVat);
    const totalR = roundMoney(netR - discR + vatR);

    setPoDetails({
      netAmount: netR.toFixed(2),
      discount: discR.toFixed(2),
      vatAmount: vatR.toFixed(2),
      totalAmount: totalR.toFixed(2),
    });
  };
  const navigate = useNavigate();
  const { id } = useParams();
  const accessToken = localStorage.getItem('accessToken');
  const [purchaseLedgerId, setPurchaseLedgerId] = useState(null);

  const [formData, setFormData] = useState({
    bill_date: '',
    bill_due_date: '',
    bill_no: '',
    job_ref: '',
    netAmount: '',
    discount: '',
    vat: '',
    total: ''
  });

  useEffect(() => {
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }
    axios.get(`${config.api_url}/ws-delivered-po-supplier`)
      .then(response => {
        if (response.data.supplier && Array.isArray(response.data.supplier)) {
          const data = response.data.supplier;
          const mapped = data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setOptions((prev) => {
            const prevOnly = (prev || []).filter(
              (o) =>
                !mapped.some(
                  (m) => String(m.value) === String(o.value)
                )
            );
            return [...mapped, ...prevOnly];
          });
        } else {
          setOptions([]);
        }
      })
      .catch(() => {});
  }, [accessToken]);

  const mergePurchaseIntoPoList = (list, purchaseId, referenceNo) => {
    const arr = Array.isArray(list) ? list : [];
    const pid = Number(purchaseId);
    if (!pid || Number.isNaN(pid)) return arr;
    if (arr.some((p) => Number(p.id) === pid)) return arr;
    return [...arr, { id: pid, reference_no: referenceNo || `PO ${pid}` }];
  };

  const fetchPurchaseOrdersForSupplier = (supplierId, ensurePurchaseId, ensureReferenceNo) => {
    if (!supplierId) {
      setPurchaseOrders([]);
      return;
    }
    axios
      .get(`${config.api_url}/ws-supplier-po/${supplierId}`)
      .then((response) => {
        const next = mergePurchaseIntoPoList(
          response.data,
          ensurePurchaseId,
          ensureReferenceNo
        );
        setPurchaseOrders(next);
      })
      .catch(() => {
        setPurchaseOrders(
          mergePurchaseIntoPoList([], ensurePurchaseId, ensureReferenceNo)
        );
      });
  };

  const handleSupplierChange = (selectedOption) => {
    const supplierId = selectedOption ? selectedOption.value : null;
    setSelectedSupplier(supplierId);
    setSelectedPo('');
    setPurchaseItem([]);
    if (supplierId) {
      fetchPurchaseOrdersForSupplier(supplierId, null, null);
    } else {
      setPurchaseOrders([]);
    }
  };

  const handlePoChange = (poId) => {
    const raw = poId === '' || poId === undefined || poId === null ? '' : String(poId);
    if (!raw) {
      setPurchaseItem([]);
      setSelectedPo('');
      setFormData((prev) => ({
        ...prev,
        bill_date: '',
        bill_due_date: '',
        bill_no: '',
        job_ref: '',
      }));
      return;
    }
    axios
      .get(`${config.api_url}/ws-get-po-details-by-id/${raw}`)
      .then((response) => {
        const purchase = Array.isArray(response.data.purchase)
          ? response.data.purchase
          : [];
        if (!purchase.length) {
          setPurchaseItem([]);
          setFormData((prev) => ({
            ...prev,
            bill_date: '',
            bill_due_date: '',
            bill_no: '',
            job_ref: '',
          }));
          return;
        }
        const sumOrderDiscount = (item) =>
          (parseFloat(item.retro) || 0) +
          (parseFloat(item.promptPayment) || 0) +
          (parseFloat(item.costToServe) || 0) +
          (parseFloat(item.offInvoice) || 0) +
          (parseFloat(item.bedsLeds) || 0) +
          (parseFloat(item.sugroRetro) || 0);
        const normalizedPurchase = purchase.map((item) => {
          const lineDisc = parseFloat(item.discount_amount);
          const orderDisc = sumOrderDiscount(item);
          const discVal =
            orderDisc > 0
              ? orderDisc
              : Number.isNaN(lineDisc)
                ? 0
                : lineDisc;
          const bq =
            item.bill_qty !== undefined &&
            item.bill_qty !== null &&
            item.bill_qty !== ''
              ? parseInt(item.bill_qty, 10)
              : parseInt(item.received_qty, 10) || 0;
          return {
            ...item,
            discount_amount: Number(discVal).toFixed(2),
            bill_qty: Number.isNaN(bq) ? 0 : bq,
          };
        });
        setPurchaseItem(normalizedPurchase);
        const row0 = purchase[0];
        const ledger = response.data.ledger || {};
        if (ledger.purchase_ledger_id) {
          setPurchaseLedgerId(ledger.purchase_ledger_id);
        } else {
          setPurchaseLedgerId(null);
        }
        setFormData((prev) => ({
          ...prev,
          bill_date: ledger.raised_on || '',
          bill_due_date: ledger.due_date || '',
          bill_no:
            ledger.bill_no !== undefined && ledger.bill_no !== null
              ? String(ledger.bill_no)
              : '',
          job_ref:
            ledger.job_ref !== undefined &&
            ledger.job_ref !== null &&
            String(ledger.job_ref).trim() !== ''
              ? String(ledger.job_ref)
              : row0.purchase_job_ref != null
                ? String(row0.purchase_job_ref)
                : '',
        }));
        const supplierId = row0.supplier_id;
        const purchaseRowId = row0.purchase_id ?? raw;
        if (supplierId !== undefined && supplierId !== null && supplierId !== '') {
          setSelectedSupplier(supplierId);
          setOptions((prev) => {
            if (!Array.isArray(prev)) return prev;
            if (prev.some((o) => String(o.value) === String(supplierId))) {
              return prev;
            }
            return [
              ...prev,
              {
                value: supplierId,
                label: row0.supplier_name || `Supplier ${supplierId}`,
              },
            ];
          });
          fetchPurchaseOrdersForSupplier(
            supplierId,
            purchaseRowId,
            row0.reference_no
          );
        }
        setSelectedPo(String(purchaseRowId));
      })
      .catch(() => {
        setPurchaseItem([]);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (purchaseItem.length > 0) {
      recalculateTotals(purchaseItem);
    }
  }, [purchaseItem]);

  const handleBillQtyChange = (id, value) => {
    if (value !== '' && !/^\d+$/.test(String(value).trim())) {
      return;
    }
    const qty = value === '' ? '' : parseInt(value, 10);
    setPurchaseItem((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        if (value === '' || Number.isNaN(qty)) {
          return { ...item, bill_qty: '' };
        }
        const received = parseInt(item.received_qty, 10) || 0;
        if (qty > received) {
          Swal.fire({
            title: 'Error!',
            text: 'Bill quantity cannot exceed received quantity.',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false,
          });
          return { ...item, bill_qty: '' };
        }
        return { ...item, bill_qty: qty };
      })
    );
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();

    const formElement = document.getElementById("new_sales_order");
    const formData = new FormData(formElement);
    formData.set('type', 'INV');
    formData.set('supplier_id', selectedSupplier != null ? String(selectedSupplier) : '');
    formData.set('purchase_id', selectedPo != null ? String(selectedPo) : '');
    formData.set('total', poDetails.totalAmount || '0');
    formData.set('user_id', localStorage.getItem('user_id') || '1');

    purchaseItem.forEach((item, index) => {
      formData.append(`product_id[${index}]`, item.product_id);
      formData.append(`purchase_item_id[${index}]`, item.id);
      formData.append(
        `bill_qty[${index}]`,
        item.bill_qty === '' || item.bill_qty === undefined ? 0 : item.bill_qty
      );
    });

    const isUpdate = purchaseLedgerId != null && String(purchaseLedgerId) !== '';
    if (isUpdate) {
      formData.set('purchase_ledger_id', String(purchaseLedgerId));
    }

    const apiUrl = isUpdate
      ? `${config.api_url}/ws-update-supplier-bill`
      : `${config.api_url}/submit-supplier-bill`;

    axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      }
    })
      .then(response => {
        Swal.fire({
          title: "Success",
          text: isUpdate
            ? "Supplier bill updated successfully"
            : "Supplier bill submitted successfully",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        if (action === 'saveAndClose') {
          navigate('/PurchaseLedger');
        } else {
          setFormData({
            bill_date: '',
            bill_due_date: '',
            bill_no: '',
            job_ref: '',
            netAmount: '',
            discount: '',
            vat: '',
            total: ''
          });
          setPurchaseItem([]);
          setSelectedSupplier(null);
        }
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        Swal.fire('Error', 'There was an issue submitting the form.', 'error');
      });
  };

  const handleDiscClick = (id) => {
    let data = purchaseItem.find(item => item.id === id);
    if (data && (data.bedsLeds || data.costToServe || data.offInvoice || data.retro || data.sugroRetro || data.promptPayment)) {
      setDiscountData({
        retro: data.retro || 0,
        promptPayment: data.promptPayment || 0,
        costToServe: data.costToServe || 0,
        offInvoice: data.offInvoice || 0,
        bedsLeds: data.bedsLeds || 0,
        sugroRetro: data.sugroRetro || 0,
      });
    } else {
      setDiscountData({
        retro: "",
        promptPayment: "",
        costToServe: "",
        offInvoice: "",
        bedsLeds: "",
        sugroRetro: "",
      });
    }
  };

  useEffect(() => {
    if (id) {
      handlePoChange(id);
    }
  }, [id]);
  return (
    <div>
      <div className="modal fade" id="view-discount" tabIndex="-1">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Discount per Case</h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="adddiscount-popup">
                <form>
                  <table className="table table-bordered dataTable">
                    <tbody>
                      <tr>
                        <td>Retro</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="retro"
                            value={discountData.retro}
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Prompt Payment</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            name="promptPayment"
                            value={discountData.promptPayment}
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Cost to Serve</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={discountData.costToServe}
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Off Invoice</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={discountData.offInvoice}
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Beds & Leds</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={discountData.offInvoice}
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Sugro Retro</td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            onFocus={(e) => e.target.select()}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="/Dashboard">Dashboard</a> &gt; <span className="last-crumb">Supplier Bill</span>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <form id='new_sales_order' onSubmit={handleSubmit}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg-12 col-sm-12">
                <div className="show-order-area dashboard">
                  <div style={{ marginBottom: '20px', float: 'left', width: '100%' }}>
                    <div className="newsalesorderform">
                      <div className="row mb-3 padd-l-13px">
                        <div className="col-6 col-lg-6 col-sm-6">
                          <div className="row mb-3">
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Select Supplier <span className='red'>*</span> </label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <input type="hidden" name="supplier_id" value={selectedSupplier != null ? String(selectedSupplier) : ''} />
                              <Select
                                options={options}
                                onChange={handleSupplierChange}
                                placeholder="Select Supplier"
                                isSearchable
                                value={options.find((option) => String(option.value) === String(selectedSupplier)) ?? null}
                              />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Bill Date </label>
                            </div>
                            <div className="col-8 col-lg-3 col-sm-3">
                              <CustomDateInput name="bill_date" id="bill_date" className="form-control" value={formData.bill_date} onChange={handleChange} />
                            </div>
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Bill Due Date </label>
                            </div>
                            <div className="col-8 col-lg-3 col-sm-3">
                              <CustomDateInput name="bill_due_date" id="bill_due_date" className="form-control" value={formData.bill_due_date} onChange={handleChange} />
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Bill No <span className='red'>*</span> </label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <input type="text" name="bill_no" className="form-control" required value={formData.bill_no} onChange={handleChange} />
                            </div>
                          </div>
                        </div>
                        <div className="col-6 col-lg-6 col-sm-6">
                          <div className="row mb-3">
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Select P.O. <span className='red'>*</span> </label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <select
                                className="form-control"
                                id="purchase_id"
                                name="purchase_id"
                                value={selectedPo === null || selectedPo === undefined ? '' : String(selectedPo)}
                                onChange={(e) => handlePoChange(e.target.value)}
                              >
                                <option value="">Select P.O.</option>
                                {purchaseOrders.map(purchase => (
                                  <option key={purchase.id} value={String(purchase.id)}>
                                    {purchase.reference_no}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-4 col-lg-3 col-sm-3">
                              <label htmlFor="desc" className="col-form-label">Job Ref <span className='red'>*</span></label>
                            </div>
                            <div className="col-8 col-lg-9 col-sm-9">
                              <input type="text" name="job_ref" className="form-control" required value={formData.job_ref} onChange={handleChange} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <h5>Confirm Quantity</h5>
                      <div className="verical-scrl-wrapper common-table supplierbill-table" id="style-3">
                        <table className="table table-bordered dataTable" id="dsTable">
                          <thead>
                            <tr>
                              <th>Code</th>
                              <th>Description</th>
                              <th>PK</th>
                              <th>Size</th>
                              <th>Discount</th>
                              <th>Order Qty</th>
                              <th>Received Qty (GRN)</th>
                              <th>Bill Qty</th>
                              <th>Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {purchaseItem.map((item, index) => (
                              <tr key={item.id}>
                                <td><a href='#'>{item.code}</a></td>
                                <td>{item.product_desc}</td>
                                <td>{item.pack}</td>
                                <td>{item.size}</td>
                                <td>
                                  <a
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#view-discount"
                                    onClick={() => handleDiscClick(item.id)}
                                  >
                                    {item.discount_amount}
                                  </a>
                                </td>
                                <td> {item.quantity}</td>
                                <td>{item.received_qty}</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.bill_qty === '' || item.bill_qty === undefined ? '' : item.bill_qty}
                                    onChange={(e) => handleBillQtyChange(item.id, e.target.value)}
                                  />
                                </td>
                                <td>{(parseInt(item.received_qty, 10) || 0) - (parseInt(item.bill_qty, 10) || 0)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* <h5>Accounting Code</h5>
                      <div className="verical-scrl-wrapper common-table accountcode-table" id="style-3">
                        <table className="table table-bordered dataTable" id="dsTable">
                          <thead>
                            <tr>
                              <th>Code</th>
                              <th>Name</th>
                              <th>Category</th>
                              <th>Description</th>
                              <th>Amount</th>
                              <th>Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td><a href='#'>SKI010</a></td>
                              <td>Bank HSBC Bank 31513621</td>
                              <td>Cash and Bank</td>
                              <td><input type="text" className="form-control" placeholder="ABC" /></td>
                              <td><input type="text" className="form-control" placeholder="90" /></td>
                              <td><a href="#"><i className="fa fa-trash"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div> */}

                      <div className="purchaseform">
                        <div className="row">
                          <div className="col-6 col-lg-10 col-sm-10">
                            <div className="row mb-3">
                              <div className="col-6 col-lg-1 col-sm-1">
                                <label htmlFor="desc" className="col-form-label">Net Amount </label>
                              </div>
                              <div className="col-6 col-lg-2 col-sm-2">
                                <input type="text" className="form-control" id="net_amount" name="net_amount" value={poDetails.netAmount} readOnly />
                              </div>

                              <div className="col-6 col-lg-1 col-sm-1">
                                <label htmlFor="desc" className="col-form-label">Discount </label>
                              </div>
                              <div className="col-6 col-lg-2 col-sm-2">
                                <input type="text" className="form-control" id="discount" name="discount" value={poDetails.discount} readOnly />
                              </div>

                              <div className="col-6 col-lg-1 col-sm-1">
                                <label htmlFor="desc" className="col-form-label">VAT </label>
                              </div>
                              <div className="col-6 col-lg-2 col-sm-2">
                                <input type="text" className="form-control" id="vat_amount" value={poDetails.vatAmount} readOnly />
                              </div>

                              <div className="col-6 col-lg-1 col-sm-1">
                                <label htmlFor="desc" className="col-form-label">Total </label>
                              </div>
                              <div className="col-6 col-lg-2 col-sm-2">
                                <input type="text" className="form-control" id="total_amount" name="total" value={poDetails.totalAmount} readOnly />
                              </div>
                            </div>
                          </div>

                          {/* <div className="col-6 col-lg-2 col-sm-2">
                            <div style={{ float: "right", width: "100%" }}>
                              <a href="#" className="create-catalogue-btn"><i className='fa fa-plus'></i>&nbsp;Accounting Code</a>
                            </div>
                          </div> */}
                        </div>
                      </div>

                      <a href="#" className="common-closebtn">Cancel</a> &nbsp;
                      <div className="btn-group bouble-btn" role="group" aria-label="Basic example">
                        <button type="button" className="saveclose" onClick={(e) => handleSubmit(e, 'saveAndClose')}>Save & Close</button>
                        <button type="button" className="savenew" onClick={(e) => handleSubmit(e, 'saveAndNew')}>Save & New</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default EditSupplierBill; 
